interface ServerAbstractType {
  condition: string;
  operator: string;
}

enum ServerPredicateStyleConditionType {
  Condition = 'Common.ObjectModel.Styles.PredicateStyleConditionNode, Common',
  Operator = 'Common.ObjectModel.Styles.PredicateStyleOperatorNode, Common',
}

enum ServerPredicateFilterConditionType {
  Condition = 'Common.ObjectModel.Feeds.PredicateFilterConditionNode, Common',
  Operator = 'Common.ObjectModel.Feeds.PredicateFilterOperatorNode, Common',
}

interface ServerSingleConditionType {
  $type: string;
  condOperator: number;
  key: string;
  objectName: string;
  propertyName: string;
  values: string[];
}

type ServerMultiConditionType = {
  $type: string;
  and: boolean;
  predicates: Array<ServerSingleConditionType | ServerMultiConditionType>;
};

type ServerClinchCondition = ServerSingleConditionType | ServerMultiConditionType;

type SingleConditionType = ServerSingleConditionType & {
  conditionUiName: string;
  conditionKey: string;
};

type MultiConditionType = {
  $type: string;
  and: boolean;
  predicates: Array<SingleConditionType | MultiConditionType>;
  conditionKey: string;
};

type ConditionRange<T> = {
  from: T;
  to: T;
};

type ClinchCondition = SingleConditionType | MultiConditionType;

enum ConditionOperatorKey {
  Exists = 1,
  Equal = 10,
  NotEqual = 11,
  LessThan = 20,
  LessThanOrEqual = 25,
  GreaterThan = 30,
  GreaterThanOrEqual = 35,
  Contains = 40,
  NotContains = 41,
  Between = 50,
  MatchesRegularExpression = 100,
}

const ConditionOperatorKeyToText = {
  [ConditionOperatorKey.Exists]: 'Exists',
  [ConditionOperatorKey.Equal]: 'Equal',
  [ConditionOperatorKey.NotEqual]: 'Not Equal',
  [ConditionOperatorKey.LessThan]: 'Less Than',
  [ConditionOperatorKey.LessThanOrEqual]: 'Less Than Or Equal',
  [ConditionOperatorKey.GreaterThan]: 'Greater Than',
  [ConditionOperatorKey.GreaterThanOrEqual]: 'Greater Than Or Equal',
  [ConditionOperatorKey.Contains]: 'Contains',
  [ConditionOperatorKey.NotContains]: 'Not Contains',
  [ConditionOperatorKey.Between]: 'Between',
  [ConditionOperatorKey.MatchesRegularExpression]: 'Matches Regular Expression',
};

enum ConditionType {
  Date = 'date',
  Text = 'text',
  Boolean = 'boolean',
  Number = 'number',
}

enum ConditionCategory {
  Weather,
  Sport,
  Location,
  Product,
  Dsp,
  Placement,
  Adset,
  User,
  Baseball,
  Soccer,
  Basketball,
  AmericanFootball,
  Hockey,
  Olympics = 31,
  Teams = 13,
  Events,
  Players,
  Medals = 32,
  Ecommerce = 16,
  Flight,
  Hotel,
  Package,
  Car_rental,
  Car,
  Activity,
  CPG,
  CurrentWeather,
  WeatherForecast,
  WeatherForecastDay1,
  WeatherForecastDay2,
  WeatherForecastDay3,
  WeatherForecastDay4,
  WeatherForecastDay5,
  Content = 33,
}

interface ServerConditionWizardCategory {
  value: ConditionCategory;
  customDisplayName?: string;
  categories?: ServerConditionWizardCategory[];
}

interface ConditionWizardCategory extends Omit<ServerConditionWizardCategory, 'categories'> {
  title: string;
  icon: string;
  categories: ConditionWizardCategory[];
}

enum ConditionValueSelectorType {
  TextualList = 1,
  TextualStrictList,
  NumericList,
  NumericRange,
  DatesList,
  DatesRange,
  Binary,
}

export {
  ClinchCondition,
  ServerClinchCondition,
  SingleConditionType,
  ServerSingleConditionType,
  MultiConditionType,
  ServerMultiConditionType,
  ConditionOperatorKey,
  ConditionRange,
  ConditionType,
  ServerAbstractType,
  ServerPredicateStyleConditionType,
  ServerPredicateFilterConditionType,
  ServerConditionWizardCategory,
  ConditionWizardCategory,
  ConditionCategory,
  ConditionValueSelectorType,
  ConditionOperatorKeyToText,
};
